export const _LOAD_MODEL_ = 'Load:Puzzle';
export const _SAVE_MODEL_ = 'Save:Puzzle';
export const _DELETE_PUZZLE_ = 'Delete:Puzzle';

export const _PUZZLE_SELECTED_CELL_ = 'Selected:Puzzle';
export const _PUZZLE_ANSWER_OPTION_ = 'Answer:Puzzle';
export const _PUZZLE_QUESTION_OPTION_ = 'Question:Puzzle';
export const _PUZZLE_EDIT_QUESTION_OPTION_ = 'Question:Edit';
export const _PUZZLE_GROUP_OPTION_ = 'Group:Puzzle';
export const _PUZZLE_PRE_GROUP_OPTION_ = 'PreGroup:Puzzle';
export const _PUZZLE_UNGROUP_OPTION_ = 'Ungroup:Puzzle';
export const _PUZZLE_ARROW_OPTION_ = 'Arrow:Puzzle';
export const _PUZZLE_CLOSE_ALL_MODAL_ = 'Close:Puzzle';
export const _PUZZLE_SET_ANSWER_ = 'SetAnswer:Puzzle';
export const _PUZZLE_SET_QUESTION_ = 'SetQuestion:Puzzle';
export const _PUZZLE_SET_CELL_ = 'SetCell:Puzzle';


export const STATUS_OPTIONS = [
  { slug: 'draft', name: 'Rascunho' },
  { slug: 'completed', name: 'Finalizado' },
];

export const STATUS = {
  COMPLETED: 'completed',
  DRAFT: 'draft',
};

export const isPuzzleStatusCompleted = status => status === STATUS.COMPLETED;

export const getPuzzleStatusLabel = status => (isPuzzleStatusCompleted(status) ? 'Finalizado' : 'Rascunho');

export const ANSWER = {
  id: null,
  answer: null,
};

export const QUESTION = {
  id: null,
  question: null,
  answer_id: null,
  size_id: null,
  size: {
    size: 9,
    name: 'Pequeno',
    slug: 'pequeno',
  },
};

export const CELL_SIZE = 60;

export const ARROW = {
  id: null,
  name: null,
  slug: null,
};

export const CELL = {
  id: null,
  type: 'col',
  hide: false,
  text: null,
  active: false,
  positionx: 0,
  positiony: 0,
  updated: true,
  direction: { ...ARROW },
  settings: {
    bold: true,
    font_size: 9,
    background: '#FFF7CC',
  },
  answer_id: null,
  question_id: null,
  answer: { ...ANSWER },
  height: 100,
  children: [],
  question: { ...QUESTION },
  isAnswer: false,
  isQuestion: false,
  parent_id: null,
  direction_id: null,
  arrow_position: { ...ARROW },
  arrow_direction: { ...ARROW },
  arrow_position_id: null,
  arrow_direction_id: null,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 1,
  template_id: null,
  status: 'draft',
  rows: 10,
  columns: 10,
  settings: {
    puzzleTypeStyle: 'square',
    puzzleTitleColor: '#bbb',
    prioritize_quality: true,
    useCurrentGameReference: true,
    puzzleFontSize: 9,
    bankAnswersCount: 3,
    bank: [],
  },
  created_at: new Date(),
  updated_at: new Date(),
  f_created_at: new Date().toLocaleDateString(),
  f_updated_at: new Date().toLocaleDateString(),
  table: [{ ...CELL }],
};

export const SPLIT = [
  { value: 25, label: '1/3 da linha' },
  { value: 50, label: '1/2 da linha' },
  { value: 75, label: '2/3 da linha' },
  { value: 0, label: '2 colunas' },
];

export const EXAMPLE_GRID_FILE = [
  '..E.......',
  '..S.......',
  '..T.......',
  'CRUZADAS..',
  '..D.......',
  '..I...J...',
  '.MOLOTOV..',
  '......G...',
  '......O...',
  '..........',
];
